import { changeRoute } from "@/router";

export const checkIfArrayElementsMatch = (
    existingRoles: string[],
    storedRoles: any,
) => {
    return existingRoles.some((r) => storedRoles.indexOf(r) >= 0);
};

export const redirectUserBasedOnPermissions = (
    userPermissions: string[],
    origin: any,
) => {
    if (userPermissions.length > 0) {
        // For partner users, if an origin is provided we will redirect to it
        // when they are logged in.
        if (origin) {
            changeRoute(origin);
        } else {
            changeRoute("/partner/transactions/order-payments");
        }
    } else {
        changeRoute("/unauthorised-access");
    }
};
